module.exports = __webpack_public_path__ + "img/defaultVoucherIco.2e906398.png";